// import http from './http'
import http, { ensureCsrfCookie } from './http'

function withSessionHeaders() {
	const sid = localStorage.getItem('cart_session')
	return sid ? { 'X-Cart-Session': sid } : {}
}

export async function getCart() {
	try {
		const res = await http.get('/api/cart', { headers: withSessionHeaders() })
		const sid = res.headers['x-cart-session'] || res.headers['X-Cart-Session']
		if (sid) {
			localStorage.setItem('cart_session', sid as string)
		} else {
			// إذا لم يعد الخادم يعيد session للضيف بعد الدمج، امسح المخزن المحلي
			localStorage.removeItem('cart_session')
		}
		return res.data
	} catch (error: any) {
		// إذا كان الخطأ 401 (غير مصرح)، إرجاع عربة فارغة
		if (error.response?.status === 401) {
			return { items: [], total_cents: 0, total_items: 0 }
		}
		// إعادة رمي الخطأ للخطأ الأخرى
		throw error
	}
}

export async function updateCartServices(payload: any): Promise<any> {
	const { data } = await http.post('/api/cart/services', payload)
	return data
  }
  
  export async function uploadCartAttachment(formData: FormData): Promise<any> {
	const { data } = await http.post('/api/cart/attachment', formData, {
	  headers: { 'Content-Type': 'multipart/form-data' },
	})
	return data
  }



// export async function createOrder(payload: {
// 	payment_method: string
// 	payment_details?: any
//   }): Promise<any> {
// 	await ensureCsrfCookie()
// 	const { data } = await http.post('/api/cart/order', payload)
// 	return data
//   }

// مثال create order
export async function createOrder(payload: any) {
	const res = await http.post('/api/cart/order', payload)
	return res.data
  }


export async function addToCart(product_id: number, quantity = 1) {
	try {
		const res = await http.post('/api/cart/add', { product_id, quantity }, { headers: withSessionHeaders() })
		const sid = res.headers['x-cart-session'] || res.headers['X-Cart-Session']
		if (sid) localStorage.setItem('cart_session', sid as string)
		return res.data
	} catch (error: any) {
		if (error.response?.status === 401) {
			throw new Error('يجب تسجيل الدخول والتحقق من البريد الإلكتروني لإضافة منتجات للعربة')
		}
		throw error
	}
}

export async function updateCartItem(itemId: number, quantity: number) {
	try {
		const res = await http.patch(`/api/cart/items/${itemId}`, { quantity }, { headers: withSessionHeaders() })
		return res.data
	} catch (error: any) {
		if (error.response?.status === 401) {
			throw new Error('يجب تسجيل الدخول والتحقق من البريد الإلكتروني لتعديل العربة')
		}
		throw error
	}
}

export async function removeCartItem(itemId: number) {
	try {
		const res = await http.delete(`/api/cart/items/${itemId}`, { headers: withSessionHeaders() })
		return res.data
	} catch (error: any) {
		if (error.response?.status === 401) {
			throw new Error('يجب تسجيل الدخول والتحقق من البريد الإلكتروني لحذف منتجات من العربة')
		}
		throw error
	}
}

export async function applyCoupon(code: string) {
	try {
		const res = await http.post('/api/cart/coupon', { code }, { headers: withSessionHeaders() })
		return res.data
	} catch (error: any) {
		if (error.response?.status === 401) {
			throw new Error('يجب تسجيل الدخول والتحقق من البريد الإلكتروني لتطبيق الكوبون')
		}
		throw error
	}
}

export async function removeCoupon() {
	try {
		const res = await http.delete('/api/cart/coupon', { headers: withSessionHeaders() })
		return res.data
	} catch (error: any) {
		if (error.response?.status === 401) {
			throw new Error('يجب تسجيل الدخول والتحقق من البريد الإلكتروني لإزالة الكوبون')
		}
		throw error
	}
}



